import axios from 'axios';

export const SET_NOTIFICATION_COUNT = "SET_NOTIFICATION_COUNT"
export const IS_SLIDER = "IS_SLIDER"
export const IS_GALLERY_IMAGE_UPLOAD = "IS_GALLERY_IMAGE_UPLOAD"
export const IS_PROD_FROM_LISTING = "IS_PROD_FROM_LISTING"

export const setNotificationData = ({ token }) => {
    return dispatch => {
        let url = `/marketplace/static/php/web/b2bWebsite.php?action=getApprovalDeletionCount&token=${token}&pageNo=1`;
        axios.get(url).then(res => {
            const rsp = res.data
            let notificationData = ""
            if (rsp && Object.values(rsp).length > 0) {
                notificationData = rsp
            }
            dispatch({
                type: SET_NOTIFICATION_COUNT,
                payload: notificationData
            });
        });
    };
};

export const setSlider = (status) => {
    return {
        type: IS_SLIDER,
        payload: status
    };
};

export const setGalleryImageUpload = (status) => {
    return {
        type: IS_GALLERY_IMAGE_UPLOAD,
        payload: status
    };
};

export const setProdFromListing = (status) => {
    return {
        type: IS_PROD_FROM_LISTING,
        payload: status
    };
};